import { ITag } from '../Tag/tag';
import { AreaEnum } from '../index';

export enum StaffRoleEnum {
	CUSTOM = '0',
	HIGH_LEVEL = '1',
	READ_ONLY = '2',
}

export enum TagEnum {
	MAJOR = '1',
	TEAM = '2',
}

export interface IAccount {
	id: string;
	areaCode: AreaEnum;
	mobile: string;
	name?: string;
	name2?: string;
	email?: string;
	avatar?: string;
	activateFlag?: 0 | 1;
}

export interface IAddAccount {
	areaCode: AreaEnum;
	mobile: string;
	name?: string;
	name2?: string;
	email?: string;
	avatar?: string;
}

export interface IEditAccount {
	name: string;
	name2: string;
	email: string;
	avatar: string;
}

export type IStaff = {
	id: string;
} & IAddStaff;

export type IAddStaff = {
	role?: StaffRoleEnum;
} & IAddAccount;

export type IAddMember = {
	teams: ITag[];
	ability: ITag[];
} & IAddAccount;

export type IMember = {
	id: string;
	teams: ITag[];
	ability: ITag[];
	accountId: string;
	myTeam?: string;
} & IAccount;
